import { styled } from "styled-components";

import { colourScheme } from "utils/styling/colours";

export const ImageGalleryWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 1rem;
    padding: 1rem 1rem;
`;
export const SortFilterContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    align-items: center;
    margin-bottom: 1.25rem;
`;

export const LoaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    flex-shrink: 0;
    width: 100%;
    flex: 1 0 auto;
    margin-bottom: 1rem;
`;

export const FormControl = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 1.25rem;
`;

export const MenuItem = styled.option`
    font-size: 1rem;
    padding: 0.625rem;
`;

export const SearchInput = styled.input`
    padding: 0.625rem;
    font-size: 1rem;
    border: 0.0625rem solid ${colourScheme.white};
    border-radius: 0.25rem;
    flex: 1;
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 1rem;
`;
export const ImageWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 1rem;
    & > a {
        text-align: center;
    }
`;
